import DefaultButton from '@/components/common/default/DefaultButton';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { usePagination } from 'react-instantsearch';
import { twMerge } from 'tailwind-merge';

export default function SkusMobileAlgoliaPagination() {
  const { pages, currentRefinement, refine, canRefine } = usePagination();

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-my-10 tw-w-full">
      <DefaultButton
        className={twMerge(
          'tw-p-2 tw-rounded-md tw-border tw-bg-white tw-shadow-sm tw-transition-all tw-duration-200 tw-text-base sm:tw-text-lg',
          currentRefinement === 0
            ? 'tw-opacity-50 tw-pointer-events-none'
            : 'hover:tw-bg-gray-100'
        )}
        onClick={() => refine(currentRefinement - 1)}
        disabled={currentRefinement === 0}
      >
        <FaChevronLeft />
      </DefaultButton>

      <div className="tw-flex tw-gap-1 tw-overflow-x-auto tw-scrollbar-hide">
        {pages.map((page) => (
          <DefaultButton
            key={page}
            className={twMerge(
              'tw-px-3 tw-py-1 tw-rounded-md tw-border tw-bg-white tw-shadow-sm tw-transition-all tw-duration-200 tw-text-sm tw-min-w-[35px] sm:tw-min-w-[40px]',
              currentRefinement === page
                ? 'tw-bg-main tw-text-white tw-font-bold'
                : 'hover:tw-bg-gray-100',
              page !== currentRefinement &&
                (page < currentRefinement - 1 || page > currentRefinement + 1)
                ? 'hidden xs:block sm:inline-flex'
                : ''
            )}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              refine(page);
            }}
          >
            {page + 1}
          </DefaultButton>
        ))}
      </div>

      <DefaultButton
        className={twMerge(
          'tw-p-2 tw-rounded-md tw-border tw-bg-white tw-shadow-sm tw-transition-all tw-duration-200 tw-text-base sm:tw-text-lg',
          !canRefine
            ? 'tw-opacity-50 tw-pointer-events-none'
            : 'hover:tw-bg-gray-100'
        )}
        onClick={() => refine(currentRefinement + 1)}
        disabled={!canRefine}
      >
        <FaChevronRight />
      </DefaultButton>
    </div>
  );
}
